module.exports = __webpack_public_path__ + "img/imagen2.ef7eee82.png";